import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";

import type { IAxiosErrorStore } from "@/stores/axiosErrorStore/types";

export const useAxiosErrorStore = create<IAxiosErrorStore>()(
  subscribeWithSelector(
    devtools((set) => ({
      error: null,
      setError: (error) => {
        set({ error });
      },
    })),
  ),
);
